import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";


export interface Properties2 {}

export interface CustomeCreateAccountParameter extends ApiParameter {
    firstName?: string;
    lastName?: string;
    companyName?: string;
    email?: string;
    phone?: string;
    accountNumber?: string;
}

export interface CreditDataResultModel {}

const CreateAccountUrl = "/api/v2/existinguserregistration";

export async function customCreateAccount(parameter: CustomeCreateAccountParameter) {
    const response = await post<CreditDataResultModel>(CreateAccountUrl, parameter);
    return response;
}
